import { patchState, signalStoreFeature, withMethods, withState } from '@ngrx/signals';
import { QCScope, QCType } from '@construction/models/construction-project.model';

/** Owns `qcTypes`, `qcScopes`, and `qcConfigPublished`, each with a dedicated update method. */
export function withQcConfig() {
  return signalStoreFeature(
    withState({
      qcTypes: [] as QCType[],
      qcScopes: [] as QCScope[],
      qcConfigPublished: false,
    }),
    withMethods((store) => ({
      updateQCTypes(qcTypes: QCType[]): void {
        patchState(store, { qcTypes });
      },
      updateQCScopes(qcScopes: QCScope[]): void {
        patchState(store, { qcScopes });
      },
      updateQCConfigPublished(qcConfigPublished: boolean): void {
        patchState(store, { qcConfigPublished });
      },
    })),
  );
}
